import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBg4ZbUZRZyPmCGOXAhZ9W_X7KcxFDeSog",
    authDomain: "instaclone-app-33c10.firebaseapp.com",
    projectId: "instaclone-app-33c10",
    storageBucket: "instaclone-app-33c10.appspot.com",
    messagingSenderId: "733809845572",
    appId: "1:733809845572:web:7efe60f2685f60a5b72311"
  });

const db = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export {db, auth, storage};